import { render, staticRenderFns } from "./add_placard.vue?vue&type=template&id=bb0d2e1c&scoped=true"
import script from "./add_placard.vue?vue&type=script&lang=js"
export * from "./add_placard.vue?vue&type=script&lang=js"
import style0 from "./add_placard.vue?vue&type=style&index=0&id=bb0d2e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0d2e1c",
  null
  
)

export default component.exports